const APP_PATH_RE =
  /(\/(?:applications|funding|coach\/document-reviews|coach\/reviews|coach\/funding-reviews|community\/posts)[^\s"'<>]*)/i;

function rewriteLegacyCoachReviewPath(path) {
  if (path.startsWith('/coach/reviews')) {
    return path.replace('/coach/reviews', '/coach/document-reviews');
  }
  return path;
}

export function notificationPath(notification) {
  const link = String(notification?.link || '').trim();
  if (link.startsWith('/')) {
    return rewriteLegacyCoachReviewPath(link);
  }
  const fromMessage = String(notification?.message || '').match(APP_PATH_RE);
  return fromMessage ? rewriteLegacyCoachReviewPath(fromMessage[1]) : null;
}
